import { observer } from "mobx-react-lite";
import type { RefObject } from "react";
import authStore from "../../stores/auth/authStore";
import uiStore from "../../stores/uiStore";
import Button from "../Button";

type ContestFormCorrectAnswerProps = {
   answer: string;
   companyName: string;
   isSignedUp: boolean;
   signingUp: boolean;
   onSignup: () => Promise<void>;
   buttonRef: RefObject<HTMLButtonElement | null>;
};

const ContestFormCorrectAnswer = observer(
   ({ answer, companyName, isSignedUp, signingUp, onSignup, buttonRef }: ContestFormCorrectAnswerProps) => {
      if (!authStore.isLoggedIn()) {
         return (
            <div>
               <h2>{answer} er riktig! </h2>
               <p>Du må logge inn for å delta.</p>
               <Button variant="secondary" onClick={() => uiStore.showLoginModal()}>
                  Logg inn
               </Button>
            </div>
         );
      }

      if (isSignedUp) {
         return (
            <div>
               <h2>{answer} er riktig!</h2>
               <p>{companyName} er nå med i trekningen for denne konkurransen.</p>
               <p>Vi vil ta kontakt med vinneren så fort konkurransen er over.</p>
            </div>
         );
      }

      return (
         <div>
            <h2>{answer} er riktig!</h2>
            <Button variant="secondary" onClick={onSignup} loading={signingUp} disabled={signingUp} ref={buttonRef}>
               Samle dagens lodd
            </Button>
         </div>
      );
   }
);

export default ContestFormCorrectAnswer;
